import { render, staticRenderFns } from "./KeywordsField.vue?vue&type=template&id=8711c924"
import script from "./KeywordsField.vue?vue&type=script&lang=js"
export * from "./KeywordsField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports